import { FormValidator, ValidationRules } from 'src/utils/FormValidator';

export const UserFormValidationPaths = {
  ALIAS: {
    path: 'alias',
    message: 'Error: Please enter the alias.',
  },
  FULL_NAME: {
    path: 'fullName',
    message: 'Error: Please enter the full name.',
  },
  BUSINESS_UNIT: {
    path: 'businessUnit',
    message: 'Error: Please select a business unit.',
  },
  ROLE: {
    path: 'role',
    message: 'Error: Please select a role.',
  },
} as const;

export const UserFormValidator = (): FormValidator => {
  const validator = new FormValidator();

  validator
    .addRule(
      UserFormValidationPaths.ALIAS.path,
      ValidationRules.required,
      UserFormValidationPaths.ALIAS.message,
    )
    .addRule(
      UserFormValidationPaths.FULL_NAME.path,
      ValidationRules.required,
      UserFormValidationPaths.FULL_NAME.message,
    )
    .addRule(
      UserFormValidationPaths.BUSINESS_UNIT.path,
      ValidationRules.required,
      UserFormValidationPaths.BUSINESS_UNIT.message,
    )
    .addRule(
      UserFormValidationPaths.ROLE.path,
      ValidationRules.required,
      UserFormValidationPaths.ROLE.message,
    );
  return validator;
};
